import { useMemo } from 'react';

import { StorageManager, useReadLocalStorage } from '@speeki/storage-manager';

const checkCorrectJson = (rawData: string | null): string[] => {
    try {
        const parsedExcludedSurvey = rawData && JSON.parse(rawData);

        return Array.isArray(parsedExcludedSurvey) ? parsedExcludedSurvey : [];
    } catch {
        ExcludedSurveyService.clearExcludedSurvey();
        return [];
    }
};

export class ExcludedSurveyService {
    static getRawExcludedSurvey = () =>
        StorageManager.getValue('excludedSurvey');

    static getExcludedSurvey = (): string[] => {
        const rawExcludedSurvey = ExcludedSurveyService.getRawExcludedSurvey();

        return checkCorrectJson(rawExcludedSurvey);
    };

    static setExcludedSurvey = (id: string) => {
        const current = ExcludedSurveyService.getExcludedSurvey();

        StorageManager.setValue(
            'excludedSurvey',
            JSON.stringify([...current, id]),
        );
    };

    static clearExcludedSurvey = () => {
        StorageManager.removeValue('excludedSurvey');
    };
}

export const useReadExcludedSurvey = (): string[] => {
    const rawExcludedSurvey = useReadLocalStorage('excludedSurvey');

    return useMemo(
        () => checkCorrectJson(rawExcludedSurvey),
        [rawExcludedSurvey],
    );
};
